import React from 'react';
import {
  CardMedia,
  Card,
  Typography,
  CardTitle,
  CardActions,
  Button
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CreateAProject } from '@thd-olt-component-react/project-forms';
import ProjectsHeader from '../ProjectsHeader';
import { nullStatePropTypes } from './nullStatePropTypes';
import { handleProjectCreationFromNullState, triggerProjectsInteractionAnalytics } from '../../utils/helpers';

const MobileNullView = ({
  cardTitle,
  bodyText,
  imageAlt,
  imageUrl,
  buttonText,
  componentId
}) => {
  return (
    <Card
      data-component="Projects"
      data-testid="projects-null-container"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-0',
          'sui-h-full',
          'sui-p-0',
          'sui-w-full'
        )
      }}
    >
      <div className="sui-px-4 sui-pt-4">
        <ProjectsHeader
          actions={['learnMore']}
          componentId={componentId}
        />
      </div>
      <div
        className={classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-2',
          'sui-h-full',
          'sui-overflow-hidden',
          'sui-px-4',
          'sui-py-2'
        )}
      >
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
        <div
          className={classNames(
            'sui-flex-col',
            'sui-flex',
            'sui-gap-6',
            'sui-pb-4'
          )}
        >
          <div className="sui-flex sui-flex-col sui-gap-2">
            <CardTitle
              header={(
                <Typography
                  variant="h2"
                  weight="display"
                >
                  {cardTitle}
                </Typography>
              )}
            />
            <Typography variant="body-base">
              {bodyText}
            </Typography>
          </div>
        </div>
      </div>
      <div className="sui-px-4 sui-pb-4">
        <CardActions className="sui-w-full">
          <QueryProvider cacheKey="mobile-null-view-create-project">
            <div className="sui-w-full">
              <CreateAProject
                // eslint-disable-next-line max-len
                onCreate={(newProject) => handleProjectCreationFromNullState({ newProject, hasProjects: false, componentId })}
                CustomCreateProjectActionElement={({ onClick }) => {
                  const handleClickCreateNew = (eve) => {
                    triggerProjectsInteractionAnalytics({
                      action: 'button-click',
                      id: componentId,
                      component: 'create new',
                    });
                    onClick(eve);
                  };

                  return (
                    <Button
                      variant="primary"
                      fullWidth
                      onClick={handleClickCreateNew}
                      data-component-id={componentId}
                      aria-label="Create New Project"
                    >
                      {buttonText}
                    </Button>
                  );
                }}
              />
            </div>
          </QueryProvider>
        </CardActions>
      </div>
    </Card>

  );
};

MobileNullView.propTypes = nullStatePropTypes;
MobileNullView.defaultProps = {
  cardTitle: '',
  bodyText: '',
  imageAlt: '',
  imageUrl: '',
};

export default MobileNullView;
